import Link from 'next/link';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Libs
import { SOCIAL_PROFILES_ACTION_PARAM } from '@/lib/socialprofiles/queryParams';

// Components
import Icon from '@/components/base/Icon';

// Routes
import { SOCIAL_PROFILES } from '@/routes/privateRoutes';

const footerLinks = [
    {
        href: {
            pathname: SOCIAL_PROFILES,
            query: {
                [SOCIAL_PROFILES_ACTION_PARAM.NAME]:
                    SOCIAL_PROFILES_ACTION_PARAM.VALUES.ADD_SOCIAL_PROFILES
            }
        },
        icon: 'plus-border',
        token: 'manage_profiles.add_social_profiles'
    },
    {
        href: SOCIAL_PROFILES,
        icon: 'settings',
        token: 'manage_profiles.manage_social_profiles'
    }
] as const;

export function Footer() {
    const { t } = useTranslation('layout_platform');
    return (
        <div className="flex items-center bg-icoGray-100 text-xxs dark:bg-icoDarkMode-anthracite">
            {footerLinks.map((link, index) => {
                return (
                    <div
                        key={index}
                        className="flex-1 border-icoGray-300 first:border-r dark:border-icoDarkMode-beton">
                        <Link
                            href={link.href}
                            className="flex w-full items-center justify-center gap-1.5 px-2 py-3 hover:text-icoBlue focus-visible:outline-none">
                            <Icon icon={link.icon} className="text-xs text-icoBlue" />
                            <span>{t(link.token)}</span>
                        </Link>
                    </div>
                );
            })}
        </div>
    );
}
